const actions = {
    READ_ALL_ACTION_REQUEST: "READ_ALL_ACTION_REQUEST",
    READ_ALL_ACTION_SUCCESS: "READ_ALL_ACTION_SUCCESS",
    READ_ALL_ACTION_ERROR: "READ_ALL_ACTION_ERROR",
    DYNAMIC_ACTION_REQUEST: "DYNAMIC_ACTION_REQUEST",
    DYNAMIC_ACTION_SUCCESS: "DYNAMIC_ACTION_SUCCESS",
    DYNAMIC_ACTION_ERROR: "DYNAMIC_ACTION_ERROR",
    HideModel_Action: "HideModel_Action",

    readAllAction: () => ({
        type: actions.READ_ALL_ACTION_REQUEST,
    }),

    dynamicAction: (payloads, config) => ({
        type: actions.DYNAMIC_ACTION_REQUEST,
        payloads,
        config,
    }),

    hideModelAction: () => ({
        type: actions.HideModel_Action,
    }),
};

export default actions;
